import { createFileRoute } from "@tanstack/react-router";

import Settings from "./-components/ReplaceProxiesPage";

export const Route = createFileRoute("/_app/_dashboard/proxy/replace")({
  component: Settings,
});
